import { LoadingPage } from "@hortis/ui/loading";
import { Toaster } from "@hortis/ui/sonner";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Suspense } from "react";
import { useSession } from "src/utils/session";

export const Route = createRootRouteWithContext<{
  subdomain: string;
}>()({
  component: () => {
    useSession();
    return (
      <>
        <Toaster />
        <Suspense fallback={<LoadingPage />}>
          <Outlet />
        </Suspense>
      </>
    );
  },
});
